export default __webpack_public_path__ + "static/media/012-cheetah.eb031c50.svg";